export { default } from './FixedFooter';
